export enum HttpContentType {
  'APP_JSON'='application/json',
}
